<ng-container *ngIf="company$ | async as company">
  <app-company-info [news]="firstSpotlightNews$ | async" [company]="company" [portfolio]="portfolio$ | async" [watchlist]="watchlist$ | async"></app-company-info>
</ng-container>
